import { Stack, Text } from '@ltvco/refresh-lib/theme';

import { CLASS_ACTION_REPORT_SECTION_IDS } from '../shared/constants';
import { DesktopReportSection } from '../shared/DesktopReportSection';
import { BodyParagraph, BulletList } from '../shared/reportTypography';
import { splitBodyParagraphs } from '../shared/splitBodyParagraphs';

import type { DocketDetailSections } from '../types';

export function HighlightsSection({
  case_overview,
  highlights,
}: {
  case_overview: DocketDetailSections['case_overview'];
  highlights: string[];
}) {
  const overviewParagraphs = splitBodyParagraphs(case_overview.body);
  const hasOverview = overviewParagraphs.length > 0;
  const hasRecapHighlights = (highlights?.length ?? 0) > 0;

  if (!hasOverview && !hasRecapHighlights) {
    return null;
  }

  return (
    <DesktopReportSection
      title="Highlights"
      sectionId={CLASS_ACTION_REPORT_SECTION_IDS.highlights}
    >
      <Stack spacing={hasOverview && hasRecapHighlights ? 2 : 0}>
        {hasOverview ? (
          <Stack spacing={1.5}>
            {overviewParagraphs.map((paragraph, index) => (
              <BodyParagraph key={`overview-${index}`}>
                {paragraph}
              </BodyParagraph>
            ))}
          </Stack>
        ) : null}
        {hasRecapHighlights ? (
          <BulletList component="ul" sx={{ listStyle: 'disc' }}>
            {highlights.map((highlight, index) => (
              <Text component="li" key={`${index}-${highlight}`}>
                {highlight}
              </Text>
            ))}
          </BulletList>
        ) : null}
      </Stack>
    </DesktopReportSection>
  );
}
